'use strict';
/**
 * TODO cloned from admin, should centralize
 * @ngdoc overview
 * @name blacklist
 * @description
 *
 * Based on http://stackoverflow.com/a/15090867/2108024
 *
 * This allows input fields to have a blacklist of invalid values. The blacklist should be an
 * array of values or objects.
 * Additionally, if blacklist-prop is defined, it will use that as the value to compare.
 * Example:
 * You have a list of objects that you don't want to have duplicates:
 * $scope.blacklist = [{name:'name1', otherProp:'prop1'}, {name:'NAME2', otherProp:'prop2'}]
 * You would want your DOM to look like this:
 * <input name="name" blacklist="blacklist" blacklist-prop="name">
 * <input name="otherProp" blacklist="blacklist" blacklist-prop="otherProp">
 * This would mark the input as invalid if they tried to enter name1 or name2 into the name input.
 * The blacklist is case-insensitive (BUG - see test).
 */

angular.module('msUtility').directive('blacklist', function () {
  return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      blacklist: '=',
      blacklistProp: '@'
    },
    link: function link(scope, elem, attr, ngModel) {
      ngModel.$parsers.unshift(function (value) {
        var valid = true;
        if (!_.isUndefined(scope.blacklistProp)) {
          for (var i = 0; i < scope.blacklist.length; i++) {
            if (scope.blacklist[i][scope.blacklistProp] && scope.blacklist[i][scope.blacklistProp].toLowerCase() === value.toLowerCase()) {
              valid = false;
              break;
            }
          }
        } else {
          valid = !!scope.blacklist.indexOf(value);
        }
        ngModel.$setValidity('blacklist', valid);
        return value;
      });
    }
  };
});